export default __webpack_public_path__ + "static/media/f_md-5.59e56ac8.svg";